export const GOOGLE_CALENDAR_NOT_AUTHORIZED_ERROR_CODE = 40101;
export const INACTIVE_USER_ERROR_CODE = 40102;
export const INACTIVE_TENANT_ERROR_CODE = 40103;
export const GOOGLE_CALENDAR_CANNOT_BE_SHOWN_ERROR_CODE = 40301;
